import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTitleAndUser } from '../../../../hooks/userTitle';
import axios from 'axios';
import {
  AnalysisContainer,
  ButtonTab,
  HeaderPageContent,
  TabContent,
} from './styles';
import FiiPainel from '../FIIPainel';
import AcoesPainel from '../AcoesPainel';
import StocksPainel from './Internacionais/StocksPainel.js';
import EtfsPainel from './Internacionais/EtfsPainel.js';
import ReitsPainel from './Internacionais/ReitsPainel.js';

import StockDetails from './Internacionais/StocksDetails/StocksDetails';
import EtfDetails from './Internacionais/ETFDetails/ETFDetails';

import { CompareAssets } from '../CompareAssets';
import { ResumoAcao } from '../../../../components/ResumoAcao';
import ResumoFII from '../../../../components/ResumoFII';
import { CompareAssetsFiis } from '../CompareAssetsFii';

const baseUrl = process.env.REACT_APP_API_URL;

interface IPropsSelectedActive {
  slug: string;
  type: '' | 'action' | 'fii' | 'international' | 'stock' | 'etf' | 'reit';
}

export function Analysis() {
  // @ts-ignore
  const { setTitle } = useTitleAndUser();
  const [tab, setTab] = useState(1);
  const [subTab, setSubTab] = useState(4);
  const [selectedActive, setSelectedActive] = useState<IPropsSelectedActive>({
    slug: '',
    type: '',
  });

  const { ticker } = useParams<{ ticker?: string }>();

  useEffect(() => {
    const fetchTicker = async () => {
      if (!ticker) return;

      try {
        const response = await axios.get(
          `${baseUrl}/Finance/dashboard/search?search=${ticker}`
        );

        const ativos = response.data;

        if (!ativos || ativos.length === 0) {
          console.warn(`⚠️ Ativo ${ticker} não encontrado.`);
          return;
        }

        const ativo = ativos[0];

        let type: 'action' | 'fii' | 'international' = 'action';

        if (ativo?.type?.toLowerCase() === 'international') {
          type = 'international';
        } else if (
          ativo?.type?.toLowerCase() === 'fii' ||
          ativo?.segmento?.toLowerCase().includes('fundo') ||
          ativo?.categoria?.toLowerCase().includes('fii')
        ) {
          type = 'fii';
        }

        setSelectedActive({
          slug: ticker,
          type,
        });

        setTab(type === 'fii' ? 2 : type === 'international' ? 4 : 1);
      } catch (error: any) {
        if (error.response?.status === 404) {
          console.warn(`⚠️ Ativo ${ticker} não encontrado.`);
        } else {
          console.error('❌ Erro ao buscar ticker:', error);
        }
      }
    };

    fetchTicker();
  }, [ticker]);

  function resetSelectedActive() {
    setSelectedActive({
      slug: '',
      type: '',
    });
  }

  return (
    <AnalysisContainer>
      <div
        id="ativos"
        style={{
          background: 'transparent',
          width: '100%',
          height: '480px',
          position: 'absolute',
          marginTop: '120px',
          zIndex: '-1',
        }}
      />

      <HeaderPageContent>
        <div className="backPage">
          <TabContent>
            <ButtonTab
              onClick={() => {
                setTab(1);
                resetSelectedActive();
              }}
              isActive={tab === 1}
            >
              Ações
            </ButtonTab>

            <ButtonTab
              onClick={() => {
                setTab(2);
                resetSelectedActive();
              }}
              isActive={tab === 2}
            >
              FIIs
            </ButtonTab>

            <ButtonTab
              onClick={() => {
                setTab(4);
                resetSelectedActive();
              }}
              isActive={tab === 4}
            >
              Stocks
            </ButtonTab>

            <ButtonTab
              onClick={() => {
                setTab(6);
                resetSelectedActive();
              }}
              isActive={tab === 6}
            >
              REITs
            </ButtonTab>

            <ButtonTab
              onClick={() => {
                setTab(5);
                resetSelectedActive();
              }}
              isActive={tab === 5}
            >
              ETFs
            </ButtonTab>

            <ButtonTab
              onClick={() => {
                setTab(3);
                setSubTab(4);
                resetSelectedActive();
              }}
              isActive={tab === 3}
            >
              Comparador
            </ButtonTab>
          </TabContent>

          {tab === 3 && (
            <div className="comparador">
              <ButtonTab
                onClick={() => {
                  setSubTab(4);
                  resetSelectedActive();
                }}
                isActive={subTab === 4}
              >
                FIIs
              </ButtonTab>

              <ButtonTab
                onClick={() => {
                  setSubTab(5);
                  resetSelectedActive();
                }}
                isActive={subTab === 5}
              >
                Ações
              </ButtonTab>
            </div>
          )}
        </div>
      </HeaderPageContent>

      {selectedActive.type === '' ? (
        <>
          {tab === 1 && <AcoesPainel selectedActive={setSelectedActive} />}

          {tab === 2 && (
            <FiiPainel
              onSelectedActive={({ slug, type }) => {
                setSelectedActive({
                  slug,
                  type,
                });
              }}
            />
          )}

          {tab === 4 && (
            <StocksPainel
              selectedActive={({ slug, type }: {
                slug: string;
                type: '' | 'action' | 'fii' | 'international' | 'stock' | 'etf' | 'reit';
              }) => {
                setSelectedActive({
                  slug,
                  type,
                });
              }}
            />
          )}

          {tab === 5 && (
            <EtfsPainel
              selectedActive={({ slug, type }: {
                slug: string;
                type: '' | 'action' | 'fii' | 'international' | 'stock' | 'etf' | 'reit';
              }) => {
                setSelectedActive({
                  slug,
                  type,
                });
              }}
            />
          )}

          {tab === 6 && (
            <ReitsPainel
              selectedActive={({ slug, type }: {
                slug: string;
                type: '' | 'action' | 'fii' | 'international' | 'stock' | 'etf' | 'reit';
              }) => {
                setSelectedActive({
                  slug,
                  type,
                });
              }}
            />
          )}

          {tab === 3 && subTab === 4 && <CompareAssetsFiis />}
          {tab === 3 && subTab === 5 && <CompareAssets />}
        </>
      ) : selectedActive.type === 'action' ? (
        <ResumoAcao
          slug={selectedActive.slug}
          clearActive={setSelectedActive}
          setSelectedActive={setSelectedActive}
        />
      ) : selectedActive.type === 'stock' ? (
        <StockDetails
          ticker={selectedActive.slug}
          onBack={() => {
            setSelectedActive({
              slug: '',
              type: '',
            });
          }}
        />
      ) : selectedActive.type === 'etf' ? (
        <EtfDetails
          ticker={selectedActive.slug}
          onBack={() => setSelectedActive({ slug: '', type: '' })}
        />
      ) : selectedActive.type === 'reit' ? (
        <StockDetails
          ticker={selectedActive.slug}
          onBack={() => {
            setSelectedActive({
              slug: '',
              type: '',
            });
          }}
        />
      ) : (
        <ResumoFII
          slug={selectedActive.slug}
          setSelectedActive={setSelectedActive}
          onBackAllFii={(slug, type) => {
            setSelectedActive({
              slug,
              type,
            });
          }}
        />
      )}
    </AnalysisContainer>
  );
}